import { render, staticRenderFns } from "./tableCell.vue?vue&type=template&id=2b25b803&"
import script from "./tableCell.vue?vue&type=script&lang=ts&"
export * from "./tableCell.vue?vue&type=script&lang=ts&"
import style0 from "./tableCell.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports